import React from 'react';

const dashSvgBase = {
  viewBox: '0 0 24 24',
  fill: 'none',
  'aria-hidden': true,
  focusable: false,
};

/** Sylwetka użytkownika — ten sam język co NavOptionIcons (stroke 1.65, zaokrąglenia). */
export function ProfileAvatarPlaceholderIcon({ className = 'p-dash-icon-svg', size = 52 }) {
  return (
    <svg {...dashSvgBase} className={className} width={size} height={size}>
      <g
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="9" r="3.5" />
        <path d="M6 20.5v-.5a6 6 0 0 1 12 0v.5" />
      </g>
    </svg>
  );
}

/** Ołówek / edycja awatara — spójny z pozostałymi ikonami nawigacji profilu. */
export function ProfileAvatarEditIcon({ className = 'p-dash-icon-svg', size = 16 }) {
  return (
    <svg {...dashSvgBase} className={className} width={size} height={size}>
      <g
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 19h7" />
        <path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 3 22l1.5-4.5L17 3z" />
      </g>
    </svg>
  );
}

/** Przyciski hero profilu — te same parametry obrysu co NavOptionIcons (suwaki). */
export function ProfileActionSettingsIcon({ className = 'p-dash-action-icon-svg', size = 18 }) {
  return (
    <svg {...dashSvgBase} className={className} width={size} height={size}>
      <g
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="4" y1="21" x2="4" y2="15.5" />
        <line x1="4" y1="10.5" x2="4" y2="3" />
        <circle cx="4" cy="13" r="2.25" />
        <line x1="12" y1="21" x2="12" y2="12.5" />
        <line x1="12" y1="7.5" x2="12" y2="3" />
        <circle cx="12" cy="10" r="2.25" />
        <line x1="20" y1="21" x2="20" y2="17.5" />
        <line x1="20" y1="12.5" x2="20" y2="3" />
        <circle cx="20" cy="15" r="2.25" />
      </g>
    </svg>
  );
}
